export default "__VITE_ASSET__df499aa3__"